import { render, staticRenderFns } from "./AssignOrderWarehouse.vue?vue&type=template&id=3a6188a2&"
import script from "./AssignOrderWarehouse.vue?vue&type=script&lang=js&"
export * from "./AssignOrderWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./AssignOrderWarehouse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports